module.exports = __webpack_public_path__ + "static/media/atago.41c73eec.png";